import React from "react";

const Shop = () => <div>Shop</div>;

export default Shop;